import { Injectable } from '@angular/core';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { environment } from 'src/environments/environment';

const singletonDbClient = createClient(
  environment.databaseUrl.supabase,
  environment.databaseAnonKey.supabase
);

@Injectable({
  providedIn: 'root',
})
export abstract class DatabaseService<T, K> {
  private databaseClient: SupabaseClient | null;

  constructor() {
    this.databaseClient = singletonDbClient;
  }

  public abstract getEntities(): Promise<T[]>;
  public abstract getRequest(entity: T): K;
  public abstract createEntity(entity: T): Promise<T>;
  public abstract updateEntity(uuid: string, entity: T): Promise<T>;
  public abstract deleteEntity(uuid: string): Promise<boolean>;

  protected getDatabaseClient(): SupabaseClient {
    if (this.databaseClient == null) {
      this.databaseClient = createClient(
        environment.databaseUrl.supabase,
        environment.databaseAnonKey.supabase
      );
    }
    return this.databaseClient;
  }
}
